import { JobState, State } from "../types";

export interface RemoveJobAction {
  jobId: string;
  type: "REMOVE JOB";
}

export const removeJob = (state: State, action: RemoveJobAction): State => {
  let activeJobId = state.activeJobId;
  let jobs = state.jobs;
  if (action.jobId in jobs) {
    jobs = { ...state.jobs };
    delete jobs[action.jobId];
  }
  let job = state.job;
  if (job.state === JobState.ready && job.job.id === action.jobId) {
    job = { state: JobState.initial };
    activeJobId = undefined;
  } else if (
    (job.state === JobState.aborted || job.state === JobState.loading) &&
    job.jobId === action.jobId
  ) {
    job = { state: JobState.initial };
  }
  if (jobs !== state.jobs || job !== state.job) {
    return {
      ...state,
      job,
      jobs,
      activeJobId
    };
  }
  return state;
};
